import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IconName } from '@fortawesome/free-regular-svg-icons';

//host => tag que envolve o componente

@Component({
  selector: 'sigecom-data-card',
  host: { class: 'w-full' },
  template: `
    <div
      class="bg-[#FAFAFA] border border-[#ECEDF2]  rounded-xl
      py-8 flex flex-col items-center justify-center w-full"
    >
      <div class="flex justify-center items-center h-10 w-10 rounded-full bg-blue-100">
        <fa-icon
        class="text-sigecom-info text-xl pt-0.5"
          [icon]="iconName"
        />
      </div>
      <div class="h-2"></div>
      <h1 class="text-lg text-sigecom-info font-semibold">{{dataValue}}</h1>
      <p class="text-md text-sigecom-gray">{{dataLabel}}</p>
    </div>
  `,

})
export class DataCardComponent implements OnChanges{
  @Input({required: true}) iconName!: IconName;
  @Input({required: true}) dataLabel!: string;
  @Input({required: true}) dataValue?: number;

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['dataValue']){
      let value = 0;
      if(changes['dataValue'].currentValue != undefined || changes['dataValue'].currentValue != null){
        value = changes['dataValue'].currentValue;
      }
      this.dataValue = value;
    }
  }
}
